import React, { useEffect } from 'react';

import Pagination from '@mui/material/Pagination';


const Pager=({maxPage, setPage, change1, change2, scrollT = true}) =>{
  const [pagee, setPagee] = React.useState(1);
  const handleChange = (event, value) => {
    setPage(value - 1);
    setPagee(value);
    scrollT && window.scrollTo({top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    setPagee(1);
  }, [change1, change2]);

  return (

      <Pagination count={maxPage + 1} page={pagee} onChange={handleChange} color='success'/>
    
  );
}

export default Pager;
